import ICaminhao from '../entities/Caminhao'
import ICreateCaminhaoRequest from '../entities/CreateCaminhaoRequest'
import { ICaminhaoRepository } from '../repositories/ICaminhaoRepository'

export interface ICreateCaminhao {
  execute(params: ICreateCaminhaoRequest): Promise<ICaminhao>
}

export default class CreateCaminhaoImpl implements ICreateCaminhao {
  constructor(private readonly caminhaoRepository: ICaminhaoRepository) {}

  public async execute(params: ICreateCaminhaoRequest): Promise<ICaminhao> {
    const response = await this.caminhaoRepository.create(params)
    return response
  }
}
